import { useState } from 'react';
import Icon from '@components/common/assets';
import { useToast } from '@components/common/toast';
import { useLoginModal } from '@components/loginModal/LoginModalContext';
import { useAddCompanyLike, useDeleteCompanyLike } from '@repository/companies/useCompanies';

interface Props {
  likeYn: boolean;
  companySn: number;
}

const CompanyInterestButton = ({ likeYn, companySn }: Props) => {
  const [bookmarkYn, setBookmarkYn] = useState(likeYn);
  const { isLogin, openLoginModal } = useLoginModal();
  const Toast = useToast();

  const { mutate: addCompanyLike, isLoading: isLoadingAddCompanyLike } = useAddCompanyLike(() => {
    Toast({ iconType: 'info', content: '관심 기업으로 등록되었습니다.' });
    setBookmarkYn(true);
  });
  const { mutate: deleteCompanyLike, isLoading: isLoadingDeleteCompanyLike } = useDeleteCompanyLike(() =>
    setBookmarkYn(false),
  );

  const handleClickLikeButton = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isLogin) {
      openLoginModal();
      return;
    }

    if (isLoadingAddCompanyLike || isLoadingDeleteCompanyLike) return;

    if (bookmarkYn) {
      deleteCompanyLike(companySn);
    } else {
      addCompanyLike(companySn);
    }
  };

  return (
    <a aria-label={'bookmark'} role="button" onClick={handleClickLikeButton}>
      {bookmarkYn ? (
        <Icon name="bookmarkLightFilled" width={32} height={32} />
      ) : (
        <Icon name="bookmarkLight" width={32} height={32} />
      )}
    </a>
  );
};

export default CompanyInterestButton;
